import { Scissors } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const tipos = [
  { value: "BANO", label: "Baño" },
  { value: "CORTE", label: "Corte" },
  { value: "ESTETICA_COMPLETA", label: "Estética completa" },
  { value: "DESHIDRATADO", label: "Deshidratado" },
  { value: "OTRO", label: "Otro" },
];
const estados = ["PROGRAMADO", "EN_PROCESO", "COMPLETADO", "CANCELADO"].map((e) => ({ value: e, label: e.replace("_", " ") }));

export default function Grooming() {
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);
  const { opciones: groomers } = useOpciones("/usuarios", (u) => u.nombre, (u) => ["GROOMER", "ADMIN"].includes(u.rol));

  return (
    <CrudPage
      resource="/grooming"
          seccion="grooming"
      titulo="Estética / Grooming"
          icono={<Scissors size={20} />}
      descripcion="Agenda de baños, cortes y estética canina."
      nombreSingular="servicio de estética"
      campos={[
        { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
        { name: "mascotaId", label: "Mascota", type: "select", options: mascotas, required: true },
        { name: "tipoServicio", label: "Tipo de servicio", type: "select", options: tipos, default: "BANO" },
        { name: "groomerId", label: "Atendido por", type: "select", options: groomers },
        { name: "fecha", label: "Fecha y hora", type: "datetime-local", required: true },
        { name: "estado", label: "Estado", type: "select", options: estados },
        { name: "precio", label: "Precio", type: "number" },
        { name: "notas", label: "Notas", type: "textarea", colSpan2: true },
      ]}
      columnas={[
        { key: "fecha", label: "Fecha", render: (r: any) => new Date(r.fecha).toLocaleString("es-MX") },
        { key: "mascota", label: "Mascota", render: (r: any) => r.mascota?.nombre },
        { key: "tipoServicio", label: "Servicio" },
        { key: "estado", label: "Estado", render: (r: any) => <Badge color="azul">{r.estado}</Badge> },
      ]}
    />
  );
}
